import { ChangeDetectionStrategy, Component, Input, OnInit, HostListener, ChangeDetectorRef } from '@angular/core';
import { BlockMargin } from '@service/article/article.service';
import { MarginService } from '../margin.service';

interface MediaLinksInterface
{
  type: string,
  text: string
}

@Component({
    selector: 'app-media-blog',
    templateUrl: './media-links.component.html',
    styleUrls: ['./media-links.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class MediaLinksComponent implements OnInit
{
  @Input() section: MediaLinksInterface;
  @Input() margin: BlockMargin;

  constructor(public changeDet: ChangeDetectorRef, public marginService: MarginService) { }

  ngOnInit(): void
  {
  }

  @HostListener('window:resize', ['$event'])
  public onWindowResize($event): void
  {
    this.changeDet.detectChanges();

  }
}
